var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconBikingRegular = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 4.8a1.8 1.8 0 1 0-3.6 0 1.8 1.8 0 0 0 3.6 0zm-9 12.6a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-3-4.8a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6zm17.4 4.8a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-3-4.8a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6zm-6.394-3.99a.304.304 0 0 1 .413.053l1.68 2.1a.904.904 0 0 0 .701.337H19c.499 0 .9-.401.9-.9s-.401-.9-.9-.9h-1.969l-1.406-1.762a2.098 2.098 0 0 0-2.884-.38L9.944 9.222c-1.444 1.065-1.253 3.278.348 4.08l2.108 1.054V18.6c0 .499.401.9.9.9s.9-.401.9-.9v-4.8a.9.9 0 0 0-.499-.806l-2.61-1.305a.599.599 0 0 1-.086-1.02l2.797-2.063.004.004z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBikingRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-biking-regular.e46dc9fa.svg";
export { ForwardRef as ReactComponent };